import Vue from 'vue'
export default function () {
  this.init = function () {


    Vue.filter('is_auth', function (value) {
      if (value == '0') {
        return '未实名'
      }
      if (value == '1') {
        return '已实名'
      }
 
    });


    //认购dealway
    // 1.按照收盘前半小时的均价成交
    // 2.按照当前的市价即时成交
    // 3.按照指定的价格成交
    // 4.按照下一个半小时段均价成交

    Vue.filter('subDealWay', function (value) {
      if (value == '1') {
        return '按照收盘前半小时的均价成交'
      }
      if (value == '2') {
        return '按照当前的市价即时成交'
      }
      if (value == '3') {
        return '按照指定的价格成交'
      }
      if (value == '4') {
        return '按照下个时段均价成交'
      }
    });

    // 建仓成交方式
    Vue.filter('deal_way', function (value) {
      if (value == 1) {
        return '收盘均价'
      }
      if (value == 2) {
        return '市价'
      }
      if (value == 3) {
        return '限价'
      }
      if (value == 4) {
        return '时段均价'
      }
    });

    Vue.filter('option_style', function (value) {
      if (value == 'C') {
        return '买入'
      }
      if (value == 'P') {
        return '卖出'
      }
    });

    Vue.filter('orgStatus', function (value) {
      if (value == 0) {
        return '禁用'
      }
      if (value == 1) {
        return '正常'
      }
    });

    Vue.filter('market_type', function (value) {
      if (value == 1) {
        return '股票'
      }
      if (value == 2) {
        return '指数'
      }
      if (value == 3) {
        return '商品'
      }
    });

    //出入金状态
    Vue.filter('status', function (value) {
      if (value == 0) {
        return '未审核'
      }
      if (value == 1) {
        return '成功'
      }
      if (value == 2) {
        return '驳回'
      }
    });
    //出入金支付状态
    Vue.filter('paystatus', function (value) {
      if (value == 0) {
        return '待支付'
      }
      if (value == 1) {
        return '已支付'
      }
      if (value == -1) {
        return '已退款'
      }
      if (value == 2) {
        return '支付处理中'
      }
    });

    // 平仓成交方式
    Vue.filter('close_deal_way', function (value) {
      if (value == 1) {
        return '均价'
      }
      if (value == 2) {
        return '市价'
      }
      if (value == 3) {
        return '限价'
      }
      if (value == 4) {
        return '时段均价'
      }
      if(value == 5){
        return '到期'
      }
    });

    // 平仓类型
    Vue.filter('close_type', function (value) {
      if (value == 1) {
        return '正常'
      }
      if (value == 2) {
        return '强平'
      }
    });

    Vue.filter('dateCN', function (value) {
      if(value){
        return value.replace('d', "天").replace('m', "个月").replace('w', "周")
      }else{
        return '-'
      }
      
    });

    Vue.filter('parseNum', function (value, length) {
      if (value) {
        return Number(value).toFixed(length)
      } else {
        return 0
      }
    });

    Vue.filter('fix2', function (value) {
      if (!value) {
        return 0;
      }
      return parseFloat(value).toFixed(2);
    });

    Vue.filter('fix3', function (value) {
      if (!value) {
        return 0;
      }
      return parseFloat(value).toFixed(3);
    });
    Vue.filter('rid', function (value) {
      if (value == 1) {
        return '管理员';
      }
      if (value == 2) {
        return '代理商';
      }
      if (value == 3) {
        return '客户';
      }
    });

    Vue.filter('gid', function (value) {
      if (value == 1) {
        return '组1';
      }
      if (value == 2) {
        return '组2';
      }
      if (value == 3) {
        return '组3';
      }
    });

    Vue.filter('state', function (value) {
      if (value == 0) {
        return '未审核';
      }
      if (value == 1) {
        return '正常';
      }
      if (value == 2) {
        return '审核不通过';
      }
      if (value == 3) {
        return '禁止开仓';
      }
    });

    Vue.filter('HedgeFlag', function (value) {
      if (value == 1) {
        return '投机';
      }
      if (value == 2) {
        return '套利';
      }
      if (value == 3) {
        return '套保';
      }
    });

    Vue.filter('PosiDirection', function (value) {
      if (value == 1) {
        return '净';
      }
      if (value == 2) {
        return '多头';
      }
      if (value == 3) {
        return '空头';
      }
    });

    Vue.filter('Direction', function (value) {
      if (value == 0) {
        return '买';
      }
      if (value == 1) {
        return '卖';
      }
    });

    Vue.filter('OffsetFlag', function (value) {
      if (value == 0) {
        return '开仓';
      }
      if (value == 1) {
        return '平仓';
      }
      if (value == 2) {
        return '强平';
      }
      if (value == 3) {
        return '平今';
      }
      if (value == 4) {
        return '平昨';
      }
      if (value == 5) {
        return '强减';
      }
      if (value == 6) {
        return '本地强平';
      }
    });

    Vue.filter('TradeType', function (value) {
      if (value == 0) {
        return '普通成交';
      }
      if (value == 1) {
        return '期权执行';
      }
      if (value == 2) {
        return 'OTC成交';
      }
      if (value == 3) {
        return '期转现衍生成交';
      }
      if (value == 4) {
        return '组合衍生成交';
      }
    });

    Vue.filter('PosiDirection', function (value) {
      if (value == 1) {
        return '净';
      }
      if (value == 2) {
        return '多头';
      }
      if (value == 3) {
        return '空头';
      }
    });
    Vue.filter('PositionDate', function (value) {
      if (value == 1) {
        return '今仓';
      }
      if (value == 2) {
        return '昨仓';
      }
    });
    Vue.filter('time', function (value) {
      if (!value) {
        return '';
      }
      if (value.length == 10) { //13位为js时间戳格式，包含毫秒,10位php
        value = value * 1000;
      }
      value = parseInt(value);
      return new Date(value).toLocaleString();
    });
    Vue.filter('deal_type', function (value) {
      if (value == 1) {
        return '期权交易';
      }
      if (value == 2) {
        return '互换交易';
      }
      if (value == 3) {
        return '数字货币';
      }
    });
  }





  this.status = function(value, row, index){ // 出入金状态
    if (value == 0) {
      return '未审核'
    }
    if (value == 1) {
      return '成功'
    }
    if (value == 2) {
      return '驳回'
    }
  }
  
  this.is_auth  = function(value, row, index){
    if (value == '0') {
      return '未实名'
    }
    if (value == '1') {
      return '已实名'
    }
  }



  this.state = function(value, row, index){ // 出入金状态
    if (value == 0) {
      return '未审核';
    }
    if (value == 1) {
      return '正常';
    }
    if (value == 2) {
      return '审核不通过';
    }
    if (value == 3) {
      return '禁止开仓';
    }
    if (value == 4) {
      return '注销客户';
    }
  }
  this.deal_way = function(value, row, index){ // 建仓成交方式，为了
    if (value == '1') {
      return '收盘均价'
    }
    if (value == '2') {
      return '市价'
    }
    if (value == '3') {
      return '限价'
    }
    if (value == '4') {
      return '时段均价'
    }
  }
  this.close_deal_way = function(value, row, index){ // 建仓成交方式，为了
    if(!value){
      return '-'
    }
    if (value == 1) {
      return '均价'
    }
    if (value == 2) {
      return '市价'
    }
    if (value == 3) {
      return '限价'
    }
    if (value == 4) {
      return '时段均价'
    }
    if(value == 5){
      return '到期'
    }
  }
  this.dateCN = function(value, row, index){
    return value.replace('d', "天").replace('m', "个月").replace('w', "周")
  } 
  this.market_type = function(value, row, index){
    if (value == 1) {
      return '股票'
    }
    if (value == 2) {
      return '指数'
    }
    if (value == 3) {
      return '商品'
    }
  } 
  this.option_style = function(value, row, index){
    if (value == 'C') {
      return '买入'
    }
    if (value == 'P') {
      return '卖出'
    }
  } 
  this.close_type = function(value, row, index){
    if (value == 1) {
      return '正常'
    }
    if (value == 2) {
      return '强平'
    }
  } 
}



// WEBPACK FOOTER //
// ./src/assets/js/class_filter.js